import axios from '@/config/http.js'
import api from '@/config/api.js'
import tools from '@/public/tools.js'
import qs from 'qs'
import Vue from 'vue'

Vue.prototype.LANG = {}
// Vue.prototype.MLANG = {}

//let countRequest = 0;
let cancelTokenSource =null
function cancelRequest(){
  if(cancelTokenSource){
    cancelTokenSource.cancel()
    cancelTokenSource = null
  }
}
function setQuoteParams(params) {
  //计价不能传此参数
  // if(params.active){
  // 	params.active = undefined;
  // }
  // if(params.activity_code){
  // 	params.activity_code = undefined;
  // }
  // 关联单，计价的时候不能传关联订单id
  if (params.buy_bom === 4 && params.bom_order_id) {
    params.bom_order_id = undefined
  }
  if (params.custom_pcb_ban === 3 && params.pcb_order_id) {
    params.pcb_order_id = undefined
  }
  return params
}
export default {
  getQuoteExpress({ commit }, params) {
    /* if(countRequest) return;
		countRequest ++ */
    return axios.post(api.ajaxexpress, params).then(res => {
      //countRequest = 0;
      if (res.code == 200) {
        commit('setQuoteExpressList', res.data)
        // console.log(this.state.setQuoteExpressList)
      }
    })
  },
  calcQuoteValuation({ state, commit, getters }) {
    //請求前再次判斷參數是否正確
    if (state.stay !== 'smt' && !state.canQuote[state.stay]) {
      return new Promise(res => {
        commit('setQuoteLoading', false)
        res({ code: 0, msg: 'Please enter parameters' })
      })
    }
    if (state.relation && !state.canQuote[state.relation]) {
      return new Promise(res => {
        commit('setQuoteLoading', false)
        res({ code: 0, msg: 'Please enter parameters' })
      })
    }

    commit('setQuoteLoading', true)
    //去除非计价参数
    let params = setQuoteParams(tools.deepCopy(getters.getQuoteParams))
    console.log(45, params)
    const that=this
    return axios.post(api.ajaxexpress, params).then(res => {
      //countRequest = 0;
      if (res.code == 200) {
        commit('setQuoteExpressList', res.data)
        params = setQuoteParams(tools.deepCopy(getters.getQuoteParams))
        let count = 0
        let valuation = function () {
          commit('setQuoteLoading', true)
          if (!params.express) {
            params.express = res.data[0].shipping_id
            commit('setaside_param', { key: 'express', value: params.express })
          }

          const currentExpress = res.data.find(item => item.shipping_id == params.express)
          console.log('currentExpress---',currentExpress)
          if(!currentExpress){
            params.express = res.data[0].shipping_id
            commit('setaside_param', { key: 'express', value: params.express })
          }
          count++

          // 盘中孔不参与计价
          params.via_in_pad = 'N/A'

          return axios.post(api.ajaxvaluation, params).then(rst => {
            commit('setQuoteLoading', false)
            that._vm.$alert.loading(false)
            if (rst.code == 200) {
              if (rst.hqpcb_error == 1 && count <= 6) {
                setTimeout(() => {
                  valuation()
                }, 1000)
              } else {
                commit('setQuoteValuation', rst.data)
              }
            }
            return rst
          })
        }
        return valuation()
      }
    })
  },
  // PCBA计价下仅仅计算PCB的价格
  calcPCBValuation({ state, commit, getters }) {
    
    let params = setQuoteParams(tools.deepCopy(getters.getQuoteParams))
    const that=this
    if(!params.express){
      return axios.post(api.ajaxexpress, params).then(res => {
        //countRequest = 0;
        if (res.code == 200) {
          commit('setQuoteExpressList', res.data)
          params = setQuoteParams(tools.deepCopy(getters.getQuoteParams))
          let count = 0
          let valuation = function () {
            if (!params.express) {
              params.express = res.data[0].shipping_id
              commit('setaside_param', { key: 'express', value: params.express })
            }
            count++

            // 盘中孔不参与计价
            params.via_in_pad = 'N/A'

            return axios.post(api.ajaxvaluation, params).then(rst => {
              if (rst.code == 200) {
                if (rst.hqpcb_error == 1 && count <= 6) {
                  setTimeout(() => {
                    valuation()
                  }, 1000)
                } else {
                  commit('setQuoteValuation', rst.data)
                }
              }
              return rst
            })
          }
          return valuation()
        }
      })
    }
    else{
      let count = 0
      let valuation = function () {
        count++
        // 盘中孔不参与计价
        params.via_in_pad = 'N/A'
        return axios.post(api.ajaxvaluation, params).then(rst => {
          if (rst.code == 200) {
            if (rst.hqpcb_error == 1 && count <= 6) {
              setTimeout(() => {
                valuation()
              }, 1000)
            } else {
              commit('setQuoteValuation', rst.data)
            }
          }
          return rst
        })
      }
      return valuation()
    }
  },
  getStepPrice({ state, commit, getters }){
    let  params = setQuoteParams(tools.deepCopy(getters.getQuoteParams))
    // 拼板不显示阶梯价
    if(params.units > 1){
      commit('setStepPrice', [])
      return false
    }
    commit('setStepPrice', [])
    commit('setIsLoadingStep', true)
    const CancelToken = axios.CancelToken;
    cancelTokenSource = CancelToken.source()
    
    // 盘中孔不参与计价
    params.via_in_pad = 'N/A'

    return axios.post(api.ajaxvaluation, {...params, show_step: 1},{ cancelToken: cancelTokenSource.token }).then(res => {
      if (res.code == 200) {
        commit('setStepPrice', res.data.step_price)
      }
      setTimeout(()=>{
        commit('setIsLoadingStep', false)
      },500)
      return res.data.step_price || []
    }).finally(()=>{
      commit('setIsLoadingStep', false)
    })
  },
  addtoCart({ rootState, state ,getters }) {
    cancelRequest()
    let params = getters.getQuoteParams
    // console.log(rootState, state)
    const { isChangeParams, changeParams } = rootState
    if(isChangeParams) {
      params.modify_status = 1
      params.relate_id = changeParams.relate_id
      params.gerber_file_is_change = state.gerberFileIsChange
    }

    params.engineer_emails = state.engineerEmails

    //  前台计价页是否显示解析成功
    params.web_use_analyze_suc = state.analyzeSuccess

    // console.log(88, params, getters.getQuoteValuation)
    this._vm.$alert.loading(true)
    delete params.pcbParsingFile
    return axios.post(api.addToCart, params).then(res => {
      // this._vm.$alert.loading(false)
      //已是登錄狀態 提交到購物車 個人中心未做直接跳轉
      if (res.code == 200) {
        /* 谷歌电子商务GA4事件 */
        try {
          if (!window.dataLayer) {
            window.dataLayer = []
          }
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'USD',
              value: Number(getters.getQuoteValuation.total),
              items: [
                {
                  item_name: res.data.order_sn,
                  item_id: res.data.order_id,
                  price: Number(getters.getQuoteValuation.total)
                }
              ]
            }
          })
        } catch (error) {
          console.error(error)
        }

        if (params.service === 'bom') {
          //bom跳轉到成功要麽
          this._vm.$alert.loading(true)
          window.location.href = '/order/ordersuccess?order_id=' + res.data.order_id
        } else {
          // 加入购物车成功后，不需要弹出上传文件弹窗
          this._vm.$alert.loading(true)
          window.location.href = '/order/cart/type/1'
          // window.location.href = "/order/cart/type/1?id="+res.data.order_id;
        }
      } else {
        this._vm.$alert.loading(false)
        return res
      }
    }).finally(()=>{
      // setTimeout(()=>{
      //   this._vm.$alert.loading(false)
      // },1000 * 5)
      
    })
  },
  quoteRecodeNonMember({ getters }, email) {
    let params = getters.getQuoteParams
    params.email = email
    return axios.post(api.ajaxrecodeNonMember, params)
  },
  resetQuoteParams({ commit }) {
    commit('resetQuoteParams')
  },
  getAjaxQuoteParams({ commit }, quoteid) {
    return axios.get(api.quoteAjaxGetDfmQuote, { params: { quoteid } }).then(res => {
      if (res.code === 200) {
        commit('setAjaxQuoteParams', res.vars)
      }
    })
  },
  async getLanguge({ commit }, { langKey, params }) {
    console.log('action getLanguge', langKey, params)
    const langData = tools.getSlocal(langKey)
    if(langData) {
      return new Promise((reslove) => {
        commit('setLanguageChange', { key: langKey, data: langData })
        tools.setSlocal(langKey, langData)
        Vue.prototype[langKey] = langData;
        Vue.prototype[langKey].resoleLANG = function(key, values){
          if(values) return tools.resoleLANG(langData[key],values);
          return langData[key];
        }
        reslove(langData)
      })
    }

    let url = api.ajaxgetlang
    if(params) {
      url += '?'+qs.stringify(params) 
    }

    const res = await axios.get(url)
    console.log('action getLanguge data', res)
    commit('setLanguageChange', { key: langKey, data: res.data })
    tools.setSlocal(langKey, res.data)
    Vue.prototype[langKey] = res.data;
    Vue.prototype[langKey].resoleLANG = function(key, values){
      if(values) return tools.resoleLANG(res.data[key],values);
      return res.data[key];
    }
   
    return res.data
  }
}
